import type { Hotel } from '@/interfaces';
import { ImageCarousel } from '../imageCarousel/ImageCarousel';
import { Image } from '@/components/image/Image';

type Props = Pick<Hotel, 'id' | 'name' | 'images'>;

export const HotelImages = ({ id, name, images }: Props) => (
    <div className="ad-preview__media u-mb16" data-testid="hotelImages">
        <div className="image-container panorama-image-container u-border-radius-8px">
            {images?.length ? (
                <ImageCarousel id={id.toString()} images={images} altText={name} data-testid="hotelImageCarousel" />
            ) : (
                <Image altText="bilde mangler" />
            )}
        </div>
    </div>
);
